module.exports = __webpack_public_path__ + "static/media/savings-chart.adc60b6f.png";